const enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PILL = 'pill',
  OUTLINE = 'outline',
  PAGER = 'pager',
}

export default ButtonType;
